import { SAFE_BOTTOM } from "./Hud";

/** The demo's slim bar along the bottom, so the skating stays in view: the line's name and Stop demo. */
export function DemoBadge({ line, touch, onStop }: { line: string; touch: boolean; onStop: () => void }) {
  return (
    <div
      role="status"
      aria-label="Demo"
      className={`pointer-events-none absolute ${SAFE_BOTTOM} left-1/2 flex w-max max-w-[calc(100vw-2rem)] -translate-x-1/2 items-center gap-2 rounded-full border-[3px] border-ink bg-accent py-1 pl-3 pr-1 text-on-accent`}
    >
      <span className="shrink-0 text-sm font-black uppercase italic">Demo</span>
      <span className="min-w-0 truncate text-xs font-bold">{line}</span>
      <span className="hidden shrink-0 text-[11px] font-semibold opacity-75 sm:inline">
        {touch ? "· tap for the next line" : "· click for the next line"}
      </span>
      {/* On a phone nothing else ends the demo: no pad, no keys, and a tap on the park skips a line. */}
      <button
        type="button"
        onClick={onStop}
        className="pointer-events-auto shrink-0 rounded-full border-2 border-ink bg-surface px-3 py-1.5 text-center text-xs font-black uppercase italic text-on-surface hover:bg-surface-soft focus-visible:outline-4 focus-visible:outline-focus"
      >
        Stop demo
      </button>
    </div>
  );
}
